import {
  ACTION,
  MODE,
  MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

// The Render tab's run when a style preset is selected: the viewer capture is re-rendered
// in the preset's visual style. Picked over the plain render schema by
// getNextEnhancedSchema; the tab itself stays on ACTION.RENDER.
export default {
  "model_id": MODEL_ID.NANO_BANANA_STYLE_APPLY_NB2_LITE,
  "provider": PROVIDER.NANO_BANANA,
  "action": ACTION.STYLE_APPLY,
  "mode": MODE.NB2_LITE,
  // The backend rejects a run whose run_type differs from the catalog's.
  "run_type": "image_generation",
  "input_schema": {
    "type": "object",
    "properties": {
      // Optional for the backend, whose prompt template carries the "apply the style"
      // instruction; the user's text only steers it.
      "prompt": {
        "type": "string",
      },
      // Order is load-bearing: image 1 is the object (the viewer capture, uploaded per
      // click by GenerateButton), image 2 is the style preset's asset. Both are written
      // into canonical_params after the build rather than held in the form.
      "input_image": {
        "type": "array",
        "minItems": 2,
        "maxItems": 2,
        "items": {
          "type": "object",
          "properties": { "asset_id": { "type": "integer" } },
          "required": ["asset_id"],
        },
      },
    },
    // input_image is required by the backend but only exists once the button is clicked,
    // so it is left out of what useAreRequiredParamsFulfilled checks.
    "required": [],
  },
  "ui_schema": {},
}
